import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { MonetizationType, ObjectType } from '@/@types/graphql-types';
import type { TitleDetail, TitleDetailSeason } from '@/interfaces/title-details-graphql';

import { useLanguageStore } from '@/helpers/composables/useStores';
import { usePromotion } from '@/helpers/composables/usePromotion';
import { useI18n } from '@/helpers/composables/useI18n';

type TitleDetailOffer = TitleDetail['offers'][number];
type FreeMonetizations = MonetizationType.Free | MonetizationType.Ads | MonetizationType.Fast;

type FreeOffer = TitleDetailOffer extends { monetizationType: infer M }
	? M extends FreeMonetizations
		? Omit<TitleDetailOffer, 'monetizationType'> & { monetizationType: M }
		: never
	: never;


export default /*#__PURE__*/_defineComponent({
  __name: 'FreeNew',
  props: {
    title: null
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail };



const { country } = useLanguageStore();
const { tc } = useI18n();

const titleName = computed(() => (props.title as TitleDetailSeason).show?.content.title ?? props.title.content.title);
const objectType = computed(() =>
	// prettier-ignore
	props.title.objectType === ObjectType.Movie ? tc('WEBAPP_MOVIE')
	: props.title.objectType === ObjectType.Show ? tc('WEBAPP_SHOW')
	: tc('WEBAPP_SEASON')
);

const offersByFreeMonetization = computed(() => {
	const groups: Record<FreeMonetizations, Record<number, FreeOffer>> = {
		[MonetizationType.Free]: {},
		[MonetizationType.Ads]: {},
		[MonetizationType.Fast]: {},
	};

	props.title.offers
		.filter((offer): offer is FreeOffer => offer.monetizationType in groups)
		.forEach(offer => {
			groups[offer.monetizationType][offer.package.packageId] = offer;
		});

	return groups;
});

const freeOffers = computed(() => offersByFreeMonetization.value.FREE);
const avodOffers = computed(() => offersByFreeMonetization.value.ADS);
const fastOffers = computed(() => offersByFreeMonetization.value.FAST);

const hasFreeOffers = computed(
	() =>
		Object.values(offersByFreeMonetization.value).map(Object.keys).flat().length > 0 ||
		(inPromotionCatalogue.value && catalogueItem.value)
);

const { catalogueItem, inPromotionCatalogue } = usePromotion({
	title: () => props.title,
	offers: () => props.title.offers,
});

return { __sfc: true,props, country, tc, titleName, objectType, offersByFreeMonetization, freeOffers, avodOffers, fastOffers, hasFreeOffers, catalogueItem, inPromotionCatalogue }
}

})